// extracted by mini-css-extract-plugin
module.exports = {"buttons":"Presets_buttons__2eVoJ","button":"Presets_button__PPikA","active":"Presets_active__AoNdh"};